export default function (text) {
  return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
